import "./InputTextSearch.scss";
import PropTypes from "prop-types";
import searchIcon from "assets/icons/search.svg";
import { FormattedMessage, useIntl } from "react-intl";
import { VAR_TYPES } from "constants/constants";
import { useEffect, useState } from "react";
import ErrorPopupBtn from "components/alert-popup/ErrorPopupBtn";
import { ErrorPopup } from "components/alert-popup/ErrorPopup";

const InputTextSearch = ({
  errors,
  id,
  label,
  onClickSearch,
  placeholder,
  readOnly,
  required,
  type,
  onChange,
  ...props
}) => {
  const intl = useIntl();
  const [val, setVal] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  useEffect(() => {
    setVal(props.value);
  }, [props.value]);

  return (
    <div className="input-text-search" id={id}>
      <div className="overlap-group">
        <div className="flex-col">
          {label && (
            <div className="label sourcesanspro-normal-shadow-blue-14px">
              <label className={errors?.ref ? "label-error" : "label-standard"}>
                <FormattedMessage
                  id={label.id}
                  defaultMessage={label.defaultMessage}
                />
                {required && "*"}
              </label>
              {errors?.ref && (
                <ErrorPopupBtn setShowErrorPopup={setShowErrorPopup} />
              )}
              {showErrorPopup && (
                <ErrorPopup
                  errors={errors}
                  showErrorPopup={showErrorPopup}
                  setShowErrorPopup={setShowErrorPopup}
                  label={label || label?.id}
                  errorMessage={props.errorMessage}
                  errorValue={props.errorValue}
                />
              )}
            </div>
          )}
        </div>
        <div className={`input-search ${!readOnly ? "view-cursor" : ""}`}>
          <input
            id={`input-text-search-${id}`}
            className={`input-placeholder sourcesanspro-normal-gray-suit-18px ${
              !readOnly ? "view-cursor" : ""
            }`}
            placeholder={
              typeof placeholder === VAR_TYPES.STRING
                ? placeholder
                : intl.formatMessage(placeholder)
            }
            name={props.name}
            onChange={(e) => {
              onChange(e);
              setVal(e.target.value);
            }}
            value={props.value || ""}
            type={type || "text"}
            disabled={readOnly}
            maxLength={props.maxLength}
          />
          <img
            src={searchIcon}
            onClick={() => {
              !readOnly && onClickSearch(val);
            }}
            alt="searchIcon"
            id="search-icon"
          />
        </div>
      </div>
    </div>
  );
};
InputTextSearch.propTypes = {
  errors: PropTypes.any,
  id: PropTypes.string.isRequired,
  label: PropTypes.object,
  onClickSearch: PropTypes.func.isRequired,
  placeholder: PropTypes.object,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  type: PropTypes.string,
  onChange: PropTypes.func,
};

InputTextSearch.defaultProps = {
  errors: null,
  label: null,
  placeholder: null,
  readOnly: false,
  required: false,
  type: null,
};

export default InputTextSearch;
